export const FETCH_ASSET_NOTESTAB_DETAILS_BEGIN="FETCH_ASSET_NOTESTAB_DETAILS_BEGIN";
export const FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS="FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS";
export const FETCH_ASSET_NOTESTAB_DETAILS_FAILURE="FETCH_ASSET_NOTESTAB_DETAILS_FAILURE";



export const FETCH_ASSET_NOTE_DETAILS_BEGIN="FETCH_ASSET_NOTE_DETAILS_BEGIN";
export const FETCH_ASSET_NOTE_DETAILS_SUCCESS="FETCH_ASSET_NOTE_DETAILS_SUCCESS";
export const FETCH_ASSET_NOTE_DETAILS_FAILURE="FETCH_ASSET_NOTE_DETAILS_FAILURE";